import { useEffect } from 'react'
import './index.scss'
import { motion } from 'framer-motion'
import { useState } from 'react'

const Logo = () => {
  const [fillSVG, setFillSVG] = useState(false)
  const pathVariants = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
      },
    },
  }

  useEffect(() => {
    setTimeout(() => {
      setFillSVG(true)
    }, 4000)
  }, [])

  return (
    <div className="logo-container">
      <svg
        width="559pt"
        height="897pt"
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 142.000000 223.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          className={`svg-container ${fillSVG && 'svg1'}`}
          transform="translate(-15,240) scale(0.1,-0.1)"
          fill="none"
        >
          <motion.path
            d="M230 1230 l0 -1000 585 0 585 0 0 120 0 120 -460 0 -460 0 0 880 0
            880 -125 0 -125 0 0 -1000z"
            variants={pathVariants}
            initial="hidden"
            animate="visible"
          />
        </g>
        <g
          className={`svg-container ${fillSVG && 'svg2'}`}
          transform="translate(0,225) scale(0.1,-0.1)"
          fill="none"
        >
          <motion.path
            d="M230 1230 l0 -1000 585 0 585 0 0 120 0 120 -460 0 -460 0 0 880 0
            880 -125 0 -125 0 0 -1000z"
            variants={pathVariants}
            initial="hidden"
            animate="visible"
          />
        </g>
      </svg>
    </div>
  )
}

export default Logo
